



$( document ).ready(function() {


  /*$(document).on('click','.spf-product__form-btn-addtocart',function(e){
    e.preventDefault();
    var ID = 44670965547328; 
    alert(ID);
    
    $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: ID
    },
      dataType: 'json', 
     success: function (response) { 
      $('#cart-icon-bubble span:first').text(response.quantity);
      //console.log(data.quantity);
      //alert("DDD")
      //console.log(response)
      // var cart = new theme.CartDrawer
        //  cart.init()
        //  cart.open();
     } //
     });
  }) 
*/


  if($("body").find(".featured-topics-main-container").length) {
    if(window.location.hash){
      let hash = window.location.hash.substring(1)
      $("a.featured-topic-"+hash).addClass("current");
      $(".content-featured-topic .rich-text__text").hide();
      $("#"+hash).show();
    }else {
      $(".tag-list-banner-container a:first-child").addClass("current");
      $(".content-featured-topic .rich-text__text:first-child").show();
    }

    $(".tag-list-banner-container a").on("click", function(e) {
      //e.preventDefault();
      $(".tag-list-banner-container a").removeClass("current");
      $(this).addClass("current");
      $(".content-featured-topic .rich-text__text").hide();
      $($(this).attr('href')).show();
    });

    $(".footer-block__details-content .list-menu__item ").click(function(e) {
      //alert('ddd');

      var currentUrl = $(location).attr('href');
      var clickedUrl = $(this).attr("href")

      if ((currentUrl.indexOf("pages/help-center") >= 0) && (clickedUrl.indexOf("pages/help-center") >= 0)) {
        //e.preventDefault();
        //var hash = clickedUrl.hash.substring(1);
        
        var hash = clickedUrl.substr(clickedUrl.indexOf("#") + 1)
        //alert(hash)

        $(".content-featured-topic .rich-text__text").hide();
        $("#"+hash).show();

        var hashString = 
        $(".tag-list-banner-container a").removeClass("current");
        //$(this).addClass("current");
        console.log($('a[href="#'+hash+'"]'))
        $('a[href="#'+hash+'"]').addClass("current");




      }
      //if (str.indexOf("Yes") >= 0)

      ///pages/help-center

      
      
    });
  }

  $(".cookie-popup-section .close, .cookie-popup-section .button").on("click", function(e) {
    e.preventDefault();
    localStorage.setItem('cookie_eskayel', 1);
    $(".cookie-popup-section").fadeOut();
  });

  let already_cookie = localStorage.getItem('cookie_eskayel');
  if(!already_cookie) {
    $(".cookie-popup-section").fadeIn();
  }

  let already_popup = localStorage.getItem('popup_eskayel');
  if(!already_popup) {
    
    setTimeout(function(){$(".klaviyo-popup-section").fadeIn();}, 3000);
  }


  $(".klaviyo-popup-section .close").on("click", function(e) {
      //alert("Dddd")
      e.preventDefault();
      localStorage.setItem('popup_eskayel', 1);
      $(".klaviyo-popup-section").fadeOut();
  });

  //

});